<app-widget-home-core
  [widget]="widget"
  [isStoreView]="isStoreView"
  [subheader]="('WIDGETS.HOME.WAREHOUSE.LAST_30_DAYS' | translate) + (local ? ' | ' + local : '')"
  (click)="onClickWidget()"
>

  <app-widget-principal-data
    [label]="'WIDGETS.HOME.WAREHOUSE.PENDENTS_TRANSFERS' | translate"
    [data]="widgetData"
    [showData]="loadedData || isStoreView"
  ></app-widget-principal-data>

</app-widget-home-core>
